"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNoAncestorBindingConstraints = isNoAncestorBindingConstraints;
const isAnyAncestorBindingConstraints_1 = require("./isAnyAncestorBindingConstraints");
function isNoAncestorBindingConstraints(condition) {
    const isAnyAncestorBindingConstraintsConstraint = (0, isAnyAncestorBindingConstraints_1.isAnyAncestorBindingConstraints)(condition);
    return (constraints) => {
        return !isAnyAncestorBindingConstraintsConstraint(constraints);
    };
}
//# sourceMappingURL=isNoAncestorBindingConstraints.js.map